<template>
    <div class="row">
        <div class="col-lg-12">
            <h1 class="page-header">Meus Compromissos</h1>

            <!-- Lista de compromissos -->
            <div class="col-xs-12">
                <list 
                    ref="vuetable" 
                    :show-empty="true" 
                    api-url="planogoverno/compromisso-profile"
                    report-title="Meus Compromissos" 
                    :fields="fields" 
                    :initial-page="1" 
                    :appendParams="filtros"
                >
                    <template slot="filters">
                        <div class="collapse" id="filtros">

                            <!-- Filtro por período -->
                            <div class="col-sm-4">
                                <label class="custom-font">Período</label>
                                <select class="form-control select-selected" v-model="filtros.periodo">
                                    <option value="">Todos</option>
                                    <option v-for="(value, index) in periodos" :value="value" :key="index">
                                        {{ value }}
                                    </option>
                                </select>
                            </div>

                            <!-- Filtro por status -->
                            <div class="col-sm-4">
                                <label class="custom-font">Status</label>
                                <select class="form-control select-selected" v-model="filtros.status">
                                    <option value="">Todos</option>
                                    <option v-for="(value, index) in status" :value="value" :key="index">
                                        {{ value }}
                                    </option>
                                </select>
                            </div>

                            <!-- Filtro buttons -->
                            <div class="col-sm-4" style="padding-top: 15px;">
                                <button 
                                    @click="$refs.vuetable.refresh()" 
                                    class="btn btn-default margem-topo"
                                    name="btnFiltrar"
                                >
                                    <font-awesome-icon :icon="'filter'" />
                                    Filtrar
                                </button>
                                <button 
                                    @click="resetFiltros()" 
                                    class="btn btn-default margem-topo" 
                                    name="btnLimpar"
                                >
                                    <font-awesome-icon :icon="'eraser'" />
                                    Limpar Filtros
                                </button>
                            </div>
                        </div>
                    </template>
                    <template slot="actions">
                        <button 
                            class="btn btn-default" 
                            data-toggle="collapse" 
                            data-target="#filtros"
                        >
                            <font-awesome-icon :icon="'filter'" /> Filtros
                        </button>
                    </template>
                    <template slot="rowrender" slot-scope="props">
                        <div class="">
                            <button 
                                title="Informações" 
                                type="button" 
                                class="btn btn-primary"
                                @click="info(props.rowData)"
                            >
                                <font-awesome-icon :icon="'info'" class="icon" />
                            </button>
                            <router-link 
                                class="btn btn-primary" 
                                :to="{ 
                                    name: 'admin_planogoverno_details', 
                                    params: { id: props.rowData.id }
                                }"
                            >
                                <font-awesome-icon :icon="'search'" class="icon" />
                            </router-link>
                            <button 
                                title="Homologar" 
                                type="button" 
                                :disabled="props.rowData.status !== 'Em andamento'
                                    || props.rowData.status === 'Concluído'
                                    || props.rowData.status === 'Cancelado'
                                    || props.rowData.status === 'Rejeitada'"
                                class="btn btn-primary"
                                @click="homologar(props.rowData)"
                            >
                                <font-awesome-icon :icon="'check'" class="icon" />
                            </button>
                            <button 
                                title="Cancelar" 
                                type="button" 
                                :disabled="props.rowData.status === 'Cancelado'
                                    || props.rowData.status === 'Rejeitada' 
                                    || props.rowData.status === 'Concluído'"
                                class="btn btn-danger" 
                                @click="cancelar(props.rowData)"
                            >
                                <font-awesome-icon :icon="'times'" class="icon" />
                            </button>
                        </div>
                    </template>
                </list>
            </div>

            <SidePlanoGoverno 
                ref="side" 
                :navs="sideConfig" 
                @homologar="homologarCompromisso"
                @cancelar="cancelarCompromisso" 
                @fechaModal="fecharSideModal"    
            />

        </div>
    </div>
</template>

<script>
import list from '@/components/common/DataTable'
import SidePlanoGoverno from '@/components/planogoverno/SidePlanoGoverno.vue'
import { request } from '@/request'

export default {
    components: { list, SidePlanoGoverno },
    data() {
        return {
            fields: [
                {
                    name: 'periodo',
                    title: 'Período',
                    filterable: true
                },
                {
                    name: 'descritivo',
                    title: 'Compromisso',
                    filterable: true
                },
                {
                    name: 'status',
                    title: 'Status',
                    filterable: true
                },
                {
                    name: '__slot:actions',
                    title: 'Ações',
                    titleClass: 'text-center col-md-3',
                    dataClass: 'text-center'
                }
            ],
            filtros: {
                periodo: '',
                status: ''
            },
            periodos: [
                '2021-2024',
                '2025-2028'
            ],
            status: [
                'Não Iniciado', 'Em andamento', 'Concluído', 'Cancelado'
            ],
            sideConfig: [
                {
                    titulo: 'Homologar',
                    subtitulo: '',
                    subtDetalhe: '',
                    largura: 900,
                    identidade: 'homologar',
                    abreProximo: false,
                    aberto: false,
                    data: null
                },
                {
                    titulo: 'Informações',
                    subtitulo: '',
                    subtDetalhe: '',
                    largura: 900,
                    identidade: 'info',
                    abreProximo: false,
                    aberto: false,
                    data: null
                },
                {
                    titulo: 'Cancelar',
                    subtitulo: '',
                    subtDetalhe: 'Justifique aqui o cancelamento',
                    largura: 500,
                    identidade: 'cancelar',
                    abreProximo: false,
                    aberto: false,
                    data: null
                }
            ],
            cache: {}
        }
    },
    methods: {
        async info(compromisso) {
            if (!compromisso || !compromisso.id) {
                console.warn("Compromisso não definido ou sem a propriedade 'id'.");
                return;
            }

            let acoes = []

            if (this.cache.hasOwnProperty(compromisso.id)) {
                acoes = this.cache[compromisso.id].acoes
            } else {
                acoes = await this.loadAcoes(compromisso.id)

                if (!Array.isArray(acoes)) {
                    console.warn('Ações esperadas como array mas recebidas: ', acoes)
                    acoes = []
                }

                const responsaveis = await this.loadResponsaveis(acoes.map(a => a.sshd_responsavel))

                acoes = acoes.map(a => {
                    const responsavel = responsaveis.find(r => r.sshd == a.sshd_responsavel)
                    return { ...a, responsavel: responsavel ? responsavel.nome : 'Não atribuído'};
                })

                this.cache[compromisso.id] = { acoes }
            }

            compromisso.acoes = acoes

            this.sideConfig[1].subtitulo = compromisso.descritivo
            this.sideConfig[1].data = compromisso
            this.$refs.side.$emit('abreModal', this.sideConfig[1].identidade)
        },
        async loadAcoes(compromissoId) {
            try {
                const { status, data } = await request.get(`planogoverno/compromisso-acao?compromisso_id=${compromissoId}`)

                if (status !== 200) {
                    this.$toastr.e('Erro ao carregar as ações deste compromisso!')
                    return []
                }

                if (!data.hasOwnProperty('data') || !Array.isArray(data.data)) {
                    console.warn('Estrutura inesperada na resposta da API:', data);
                    return [];
                }

                return data.data
            } catch (err) {
                console.error('Erro ao as ações: ', err)
                this.$toastr.e('Erro ao carregar as ações dete compromisso!')
                return []
            }
        },
        async loadResponsaveis(listaSSHD) {
            if (listaSSHD.length === 0) return []

            const { status, data } = await request.get(`/funcionario?sshds=${listaSSHD.join(',')}`)

            if (status != 200) return this.$toastr.e('Erro ao carregar as responsáveis das ações deste compromisso!')

            return data
        },
        async homologar(compromisso) {
            let acoes = null

            if (this.cache.hasOwnProperty(compromisso.id)) acoes = this.cache[compromisso.id].acoes
            else {
                // carregando as ações
                acoes = await this.loadAcoes(compromisso.id)

                // carregando os reponsaveis
                const responsaveis = await this.loadResponsaveis(acoes.map(a => a.sshd_responsavel))

                // associando os responsáveis as ações
                acoes = acoes.map(a => {
                    const responsavel = responsaveis.find(r => r.sshd === a.sshd_responsavel)
                    return { ...a, responsavel: responsavel.nome }
                })

                // adicionado cache
                this.cache[compromisso.id] = { acoes }
            }

            compromisso.acoes = [ ...acoes ]

            this.sideConfig[0].subttitulo = compromisso.descritivo
            this.sideConfig[0].data = { ...compromisso }

            this.$refs.side.$emit('abreModal', this.sideConfig[0].identidade)
        },
        cancelar(compromisso) {
            // this.modal.compromisso = compromisso
            // this.modal.visivel = true

            this.sideConfig[2].subtitulo = compromisso.descritivo
            this.sideConfig[2].data = compromisso

            this.$refs.side.$emit('abreModal', this.sideConfig[2].identidade)
        },
        async homologarCompromisso(compromissoId) {
            const [now] = new Date().toISOString().split('T')

            const { status } = await request.put(
                `planogoverno/compromisso-profile/${compromissoId}`,
                { status: 'Concluído', data_conclusao: now }
            )

            if (status != 200) return this.$toastr.e('Erro ao homologar o compromisso.')

            this.$refs.vuetable.refresh()

            this.$toastr.s('Compromisso homologado com sucesso!')

            this.$refs.side.$emit('fechaModal', this.sideConfig[0].identidade)
        },
        async cancelarCompromisso(compromissoId, justificativa) {
            this.cancelarAcoes(compromissoId)

            const { status } = await request.put(
                `planogoverno/compromisso-profile/${compromissoId}`,
                { justificativa_cancelamento: justificativa, status: 'Cancelado' }
            )

            if (status != 200) return this.$toastr.e('Erro ao cancelar o compromisso.')

            this.$refs.vuetable.refresh()

            this.$toastr.s('Compromisso cancelado com sucesso!')

            this.$refs.side.$emit('fechaModal', this.sideConfig[2].identidade)
        },
        async cancelarAcoes(compromissoId) {
            const acoes = await this.loadAcoes(compromissoId)

            if (acoes && Array.isArray(acoes)) {
                acoes.forEach(async (acao) => {
                    if (acao.status !== 'Cancelada' || acao.status !== 'Rejeitada') {
                        try {
                            await request.put(
                                `planogoverno/compromisso-acao/${acao.id}`,
                                {
                                    justificativa_rejeicao: 'Compromisso cancelado',
                                    status: 'Cancelada'
                                }
                            )
                        } catch (err) {
                            console.error(`Erro ao cancelar a ação ${acao.id}: `, err)
                        }
                    }
                })
            }
        },
        fecharSideModal(identidade) {
            this.$refs.side.$emit('fechaModal', identidade)
        },
        resetFiltros() {
            this.filtros.periodo = ''
            this.filtros.status = ''
        }
    }
}
</script>

<style scoped>
.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 100%;
    max-width: 500px;
    margin: 0px auto;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    font-family: 'Helvetica Neue', Arial, sans-serif;
    overflow: visible;
}

.modal-title {
    margin-top: 0;
    color: #00615c;
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 15px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e5e5e5;
}

.modal-footer {
    margin-top: 15px;
    text-align: right;
    border-top: 1px solid #e5e5e5;
}

.custom-font {
    font-size: 16px;
    color: #00615c;
}

.icon {
    min-width: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/plano-governo/compromisso/MeusCompromissos.vue